/* @flow weak */

'use strict';

const React = require('react');
import { get, keys, map, find, filter, contains, partition } from 'lodash';

const AnswerStore = require('../../stores/AnswerStore.jsx');
const PartStore = require('../../stores/PartStore.jsx');
const AnswerActions = require('../../actions/AnswerActions.jsx');

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const DialogRenderer = require('./DialogRenderer.jsx');

const Question = React.createClass({
  propTypes: {
    question: React.PropTypes.object.isRequired,
    validationData: React.PropTypes.object.isRequired,
    hasUserSubmitted: React.PropTypes.bool,
    parts: React.PropTypes.array.isRequired
  },

  getInitialState() {
    // Default to visible unless DefaultHidden metadata is present
    return {
      visible: !get(this.props.question.metadata, 'DefaultHidden'),
      preventAnswerDeletion: false,
      control: null
    };
  },

  parts: [],

  componentWillMount() {
    const { parts, validationData } = this.props;
    this.setupQuestion(parts, validationData);
  },

  componentWillReceiveProps({ parts, validationData }) {
    this.setupQuestion(parts, validationData)
  },

  filterParts(parts) {
    if (get(this.props.question, 'metadata.RemovePartsWithoutPricing')) {
      if (Config.skuPricing) {
        parts = filter(parts, (part) => {
          const partSkuPrices = AnswerStore.getSkuPricesForPart(part);
          return !!get(part, 'metadata.ValidWithoutPricing') || (partSkuPrices && partSkuPrices.length > 0);
        });
      } else {
        parts = filter(parts, (part) => {
          return !!get(part, 'metadata.ValidWithoutPricing') || !!get(part, 'pricing');
        });
      }
    }

    return parts;
  },

  setupQuestion(parts, validationData) {
    const { question } = this.props;
    const { visibleParts, hiddenParts } = validationData;
    const visibleOnlyWithOptions = get(question.metadata, 'VisibleOnlyWithOptions');
    var visible = validationData.visible !== undefined ? validationData.visible : this.state.visible;
    const preventAnswerDeletion = validationData.preventAnswerDeletion !== undefined ? validationData.preventAnswerDeletion : this.state.preventAnswerDeletion;

    this.parts = parts;
    const currentAnswerPartId = get(AnswerStore, ['answers', question.id, 'part', 'id']);
    if (visibleParts) {
      this.parts = filter(parts, part => visibleParts.indexOf(part.id) !== -1);

      if (currentAnswerPartId && !contains(visibleParts, currentAnswerPartId)) {
        AnswerActions.delete(question, false);
      }
    }

    if (hiddenParts) {
      this.parts = filter(parts, part => hiddenParts.indexOf(part.id) === -1);

      if (currentAnswerPartId && contains(hiddenParts, currentAnswerPartId)) {
        AnswerActions.delete(question, false);
      }
    }

    this.parts = this.filterParts(this.parts);
    
    var foundPart = find(this.parts, (p) => { return p.id == currentAnswerPartId; });
    if (currentAnswerPartId && foundPart == null) {
      AnswerActions.delete(question, false);
    }

    if (this.state.visible !== visible && !preventAnswerDeletion) {
      visible ? AnswerActions.restore(question) : AnswerActions.delete(question, true);
    }

    if (visibleOnlyWithOptions && this.parts && this.parts.length <= 1) {
      visible = false;
      validationData.visible = false;
    }

    this.setState({
      visible,
      preventAnswerDeletion,
      control: this.loadControl()
    });
    this.className = this.generateClassName(this.props.question.name);
  },

  loadControl() {
    try {
      return React.createElement(
        require('../controls/' + this.props.question.control + '.jsx'),
        { 'question': this.props.question, 'parts': this.parts, 'tabIndex': this.props.tabIndex }
      );
    } catch (e) {
      return React.createElement(
        require('../controls/_NotFound.jsx'),
        { 'question': this.props.question, 'parts': this.parts, 'tabIndex': this.props.tabIndex }
      );
    }
  },

  generateClassName(name) {
    let columnCount = '';
    if (get(this.props.question.metadata, 'ColumnCount')) {
      columnCount = ' column-count-' + get(this.props.question.metadata, 'ColumnCount');
    }
    return 'uc-question uc-q-' + name.replace(/[ :]/g, '-') + columnCount;
  },

  loadDialogLink() {
    let viewLocalizations = {en_US: 'View ', fr_CA: 'Vue '}
    let moreInfoLocalizations = {en_US: 'More Info', fr_CA: 'Plus d\'infos'}
    let moreInfoLinkText = get(this.props.question.metadata, `lang.${ln}.MoreInfoTitle`) ? viewLocalizations[ln] + get(this.props.question.metadata, `lang.${ln}.MoreInfoTitle`) : moreInfoLocalizations[ln];
    let moreInfoContent = get(this.props.question.metadata, `lang.${ln}.MoreInfoContent`) || null;
    let optionalClass = get(this.props.question.metadata, 'MoreInfoLinkClass') || '';

    if (moreInfoContent) {
      return (
        <a className={optionalClass} onClick={this.showDialog}>{moreInfoLinkText}</a>
      );
    }
    return null;
  },

  loadDialog() {
    let moreInfoLocalizations = {en_US: 'More Info', fr_CA: 'Plus d\'infos'}
    let moreInfoTitle = get(this.props.question.metadata, `lang.${ln}.MoreInfoTitle`) || get(this.props.question.metadata, `lang.${ln}.DisplayName`) || moreInfoLocalizations[ln];
    let moreInfoContent = get(this.props.question.metadata, `lang.${ln}.MoreInfoContent`) || null;
    let moreInfoContainerClass = get(this.props.question.metadata, 'MoreInfoContainerClass') || null;

    if (moreInfoContent) {
      moreInfoContent = moreInfoContent.replace("<a ", "<a target=\"_blank\" ");
      return (
        <DialogRenderer
          ref="moreInfoDialog"
          title={'<h1>' + moreInfoTitle + '</h1>'}
          containerClass={moreInfoContainerClass}>
          <div dangerouslySetInnerHTML={{ __html: moreInfoContent }}></div>
        </DialogRenderer>
      );
    }
    return null;
  },

  loadAnatomyDialog() {
    let anatomyTitle = get(this.props.question.metadata, `lang.${ln}.anatomyTitle`) ?
      get(this.props.question.metadata, `lang.${ln}.anatomyTitle`) : "Anatomy";
    let anatomyText = get(this.props.question.metadata, `lang.${ln}.anatomyText`) || '';
    let anatomyImageUrl = get(this.props.question.metadata, 'anatomyImageUrl') || '';
    if (anatomyImageUrl && !(anatomyImageUrl.indexOf('http') !== -1)) {
      anatomyImageUrl = Config.images.s3url + anatomyImageUrl;
    }

    if (anatomyTitle && anatomyImageUrl) {
      return (
        <DialogRenderer
          containerClass="uc-dialog-container uc-anatomy-dialog-container"
          ref="anatomyDialog"
          title={'<h1 >' + anatomyTitle + '</h1>'}
          buttons={[{ text: 'CLOSE', btnClass: 'uc-primary-btn' }]}>
          <div>
            <p>{anatomyText}</p>
            <img src={anatomyImageUrl} />
          </div>
        </DialogRenderer>
      );
    }
    return null;
  },

  loadAnatomyLink() {
    let anatomyTitle = get(this.props.question.metadata, `lang.${ln}.anatomyTitle`) ?
      get(this.props.question.metadata, `lang.${ln}.anatomyTitle`) : "Anatomy";
    let anatomyPictureUrl = get(this.props.question.metadata, 'anatomyImageUrl') || '';
    let anatomyLinkText = get(this.props.question.metadata, `lang.${ln}.anatomyLinkText`) ?
      get(this.props.question.metadata, `lang.${ln}.anatomyLinkText`) : "View Ring Anatomy";

    if (anatomyPictureUrl) {
      return (
        <a className="uc-anatomy-link" onClick={this.showAnatomyDialog}>
          <div><button className="fa fa-question-circle"></button></div>
          <div className="uc-anatomy-link-text">{anatomyLinkText}</div>
        </a>
      );
    }
    return null;
  },

  loadLink() {
    let moreInfoLinkText = get(this.props.question.metadata, `lang.${ln}.MoreInfoTitle`) ? get(this.props.question.metadata, `lang.${ln}.MoreInfoTitle`) : 'More Info';
    let moreInfoLink = get(this.props.question.metadata, `lang.${ln}.MoreInfoLink`) || null;

    if (moreInfoLink) {
      return (
        <a href={moreInfoLink} target="_blank">{moreInfoLinkText}</a>
      );
    }
    return null;
  },

  showDialog() {
    this.refs.moreInfoDialog.showDialog();
  },

  showAnatomyDialog() {
    this.refs.anatomyDialog.showDialog();
  },

  loadAnswerTitle() {
    const currentAnswerPart = get(AnswerStore, ['answers', this.props.question.id, 'part']);
    const showAnswerTitle = get(this.props.question.metadata, 'ShowAnswerTitle');
    if (showAnswerTitle && currentAnswerPart) {
      const partName = get(currentAnswerPart.metadata, `lang.${ln}.DisplayName`) || currentAnswerPart.name;
      return (
        <span className="uc-answer-title">
          : {partName}
        </span>
      );
    } else {
      return null;
    }
  },

  loadIsRequired() {
    if (this.props.question.control == 'Blank' || this.props.question.control == 'Locked') return (<span></span>);
    let parts = PartStore.fetchPartsForQuestion(this.props.question.id)
    const constraintKeys = keys(get(this.props.question, ['constraints']));
    const requiredKeys = find(constraintKeys, (key) => key.indexOf('Required') !== -1 || key.indexOf('required') !== -1);
    if (requiredKeys && requiredKeys.length > 0) {
      return (
        <span className="uc-required-question">*</span>
      );
    } else {
      return this.props.question.control == 'Blank' || this.props.question.control == 'Locked' || parts.length < 1 ? 
      (
        <span></span>
      )
      : (
        <span className="uc-optional-question">({Config.features.optionalText[ln] || Config.features.optionalText['en_US']})</span>
      );
    }
  },

  getDescriptionMarkup() {
    let desc = null;
    const currentAnswerPartId = get(AnswerStore, ['answers', this.props.question.id, 'part', 'id']);
    if (currentAnswerPartId && get(this.props.question.metadata, `lang.${ln}.AnswerDescription.` + currentAnswerPartId)) {
      desc = get(this.props.question.metadata, `lang.${ln}.AnswerDescription.` + currentAnswerPartId);
    } else {
      desc = get(this.props.question.metadata, `lang.${ln}.DisplayInfoText`);
    }

    return (
      <div
        className="uc-question-desc"
        style={{ display: desc ? 'block' : 'none' }}>
        {desc}
      </div>
    );
  },

  renderConstraintMessaging(messages) {
    if (!get(Config, 'features.newErrorStyling')) {
      if (messages && messages.length > 0) {
        return (
          map(messages, ({ message, class: messageClass, displayBeforeSubmission }, i) => {
            if (displayBeforeSubmission || this.props.hasUserSubmitted) {
              return (
                <div key={i} className={`uc-constraint-message uc-${messageClass || 'error'}`}>
                  {message}
                </div>
              );
            }
          })
        );
      }
    }
  },

  renderNewStyleConstraintMessaging(messages) {
    if (get(Config, 'features.newErrorStyling')) {
      if (messages && messages.length > 0) {
        return (
          map(messages, ({ message, class: messageClass, displayBeforeSubmission }, i) => {
            if (displayBeforeSubmission || this.props.hasUserSubmitted) {
              return (
                <span key={i} className={`uc-constraint-message uc-${messageClass || 'error'}`}>
                  {message}
                </span>
              );
            }
          })
        );
      }
    }
  },

  render() {
    const { question, isChild, validationData } = this.props;
    const { messaging, valid } = validationData;
    const validClass = valid !== false ? ' uc-valid-question' : ' uc-invalid-question';
    const partitionedMessages = partition(messaging, messageData => !messageData.displayAboveControl);
    const activeClass = this.state.visible && question.control != 'SaveLink' ? ' uc-active' : '';
    const hideTitle = get(question.metadata, 'DisplayQuestionTitleInControl') || get(question.metadata, 'HideQuestionTitle');
    const withoutHeader = hideTitle ? ' uc-question-without-header' : '';

    return (
      <div key={question.id} className={this.className + activeClass + withoutHeader + validClass}>
        {this.renderConstraintMessaging(partitionedMessages[0])} {this.loadAnatomyLink()}
        <div className="uc-question-header" style={{ display: hideTitle ? 'none' : 'block' }}>
          <div className={isChild ? 'uc-child-question-title' : 'uc-question-title'}>
            {get(question.metadata, `lang.${ln}.DisplayName`) || question.name}
            {this.loadAnswerTitle()}
            {this.loadLink()}
            {this.loadIsRequired()}
            {this.renderNewStyleConstraintMessaging(messaging)}
          </div>
          {get(question, 'metadata.DisplayQuestionInfoTextBelowControl') ? '' : this.getDescriptionMarkup()}

          {this.loadDialogLink()}
        </div>

        <div className="uc-question-header uc-only-error-question-header" style={{ display: hideTitle ? 'block' : 'none' }}>
            <div className={isChild ? 'uc-child-question-title' : 'uc-question-title'}>
              {this.renderNewStyleConstraintMessaging(partitionedMessages[1])}
            </div>
            {get(question, 'metadata.DisplayQuestionInfoTextBelowControl') ? '' : this.getDescriptionMarkup()}

            {this.loadDialogLink()}
        </div>

        {this.renderConstraintMessaging(partitionedMessages[1])}
        {this.state.control}

        {this.loadDialog()}
        {this.loadAnatomyDialog()}
      </div>
    );
  }
});

module.exports = Question;


// WEBPACK FOOTER //
// ./src/base/scripts/components/renderers/Question.jsx